module.exports = __webpack_public_path__ + "media/images/photo/Residential/slider3-30f51b4c4c3f63ed6e5a2836d84e86b4.png";